// saga.js
import { call, put, takeEvery } from 'redux-saga/effects'
import {
  ADD_TEAM_MEMBER_REQUEST,
  UPDATE_TEAM_MEMBER_REQUEST,
  DELETE_TEAM_MEMBER_REQUEST,
  GET_TEAM_MEMBERS_REQUEST,
} from './actionTypes'
import {
  getTeamMembersSuccess,
  getTeamMembersFailure,
  addTeamMemberSuccess,
  addTeamMemberFailure,
  updateTeamMemberSuccess,
  updateTeamMemberFailure,
  deleteTeamMemberSuccess,
  deleteTeamMemberFailure,
  getTeamMembersRequest,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'

// API calls
const fetchTeamMembersApi = (id) => axiosInstance.get('', { params: { sp: "usp_GetTeamMembersList", teamId: id } })
const addTeamMemberApi = (newMember) => axiosInstance.post('', newMember)
const updateTeamMemberApi = (updatedMember) => axiosInstance.post(``, updatedMember)
const deleteTeamMemberApi = (member) => axiosInstance.post(``, { sp: "usp_DeleteTeamMember", teamMemberId: member?.teamMemberId })

// Sagas

// Fetch team members
function* getTeamMembersSaga(action) {
  try {
    const { data } = yield call(fetchTeamMembersApi, action.payload)
    yield put(getTeamMembersSuccess(data))
  } catch (error) {
    yield put(getTeamMembersFailure(error.response?.data || error.message))
  }
}

// Add a new team member
function* addTeamMemberSaga(action) {
  try {
    const { data } = yield call(addTeamMemberApi, action.payload)
    yield put(addTeamMemberSuccess(data))
    toast.success('Team member added successfully!')
    yield put(getTeamMembersRequest(action.payload?.teamId)) // Refresh team members list
  } catch (error) {
    yield put(addTeamMemberFailure(error.response?.data || error.message))
  }
}

// Update an existing team member
function* updateTeamMemberSaga(action) {
  try {
    const { data } = yield call(updateTeamMemberApi, action.payload)
    yield put(updateTeamMemberSuccess(data))
    toast.success('Team member updated successfully!')
    yield put(getTeamMembersRequest(action.payload?.teamId))
  } catch (error) {
    yield put(updateTeamMemberFailure(error.response?.data || error.message))
  }
}

// Delete a team member
function* deleteTeamMemberSaga(action) {
  try {
    yield call(deleteTeamMemberApi, action.payload) // Pass memberId to delete
    yield put(deleteTeamMemberSuccess(action.payload)) // Pass memberId on success
    toast.success('Team member deleted successfully!')
    yield put(getTeamMembersRequest(action.payload?.teamId))// Refresh team members list
  } catch (error) {
    yield put(deleteTeamMemberFailure(error.response?.data || error.message))
  }
}

// Watcher saga
function* teamMemberSaga() {
  yield takeEvery(GET_TEAM_MEMBERS_REQUEST, getTeamMembersSaga)
  yield takeEvery(ADD_TEAM_MEMBER_REQUEST, addTeamMemberSaga)
  yield takeEvery(UPDATE_TEAM_MEMBER_REQUEST, updateTeamMemberSaga)
  yield takeEvery(DELETE_TEAM_MEMBER_REQUEST, deleteTeamMemberSaga)
}

export default teamMemberSaga
